import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuardFn],
    loadComponent: () => import('./core/layout/main-layout/main-layout').then((c) => c.MainLayout),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'clients',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./customers/customers-page/customers-page').then((m) => m.CustomersPage),
          },
          {
            path: ':customerId',
            loadComponent: () =>
              import('./customers/customer-details-page/customer-details-page').then(
                (m) => m.CustomerDetailsPage,
              ),
          },
        ],
      },
      {
        path: 'souscriptions',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./subscriptions/subscriptions-page/subscriptions-page').then(
                (m) => m.SubscriptionsPage,
              ),
          },
          {
            path: ':subscriptionId',
            loadComponent: () =>
              import('./subscriptions/subscription-details-page/subscription-details-page').then(
                (m) => m.SubscriptionDetailsPage,
              ),
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'utilisateurs',
              },
              {
                path: 'utilisateurs',
                loadComponent: () =>
                  import('./subscriptions/subscription-users/subscription-users-page/subscription-users-page').then(
                    (m) => m.SubscriptionUsersPage,
                  ),
              },
            ],
          },
        ],
      },
      {
        path: 'utilisateurs',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./users/users-page/users-page').then((m) => m.UsersPage),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./users/user-details-page/user-details-page').then((m) => m.UserDetailsPage),
          },
        ],
      },
    ],
  },
  {
    path: 'acces-refuse',
    loadComponent: () =>
      import('./core/auth/access-denied-page/access-denied-page').then((m) => m.AccessDeniedPage),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
